import { useState, useEffect, useRef } from 'react';
import styled from '@emotion/styled'

import { Grid, Card, CardHeader, CardContent, CardActionArea, CardActions, Avatar, useTheme, Button, Switch, TextField } from '@mui/material'

import { Panel, SwitchSection, Section, HebrewSpan, TagField, TagRuleDescription, ErrorList, TagRules, validateTemplate } from '../../Common'

import { BasicFlex } from '../../../../utils/Common';

import { usePageData } from '../../../../contexts/PageData';

import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import GoogleIcon from '../../../../images/GoogleIcon';

import { useQuery } from '@tanstack/react-query';

import { getSetting } from '../../apiService';

// const Card = styled.div`
//   padding: 32px;
//   border-radius: 12px;
//   border: 1px solid #e5e7eb;
//   background: white;
// `;

const Header = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 20px;
  margin-bottom: 24px;
`;

const HeaderContent = styled.div`
  flex: 1;
`;

const Title = styled.h3`
  margin: 0 0 2px 0;
  font-size: 20px;
  font-weight: 600;
  color: #111827;
`;

const Status = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 14px;
  color: #6b7280;
`;

const StatusDot = styled.span`
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #d1d5db;
`;

const Description = styled.p`
  margin: 0 0 28px 0;
  font-size: 15px;
  line-height: 1.6;
  color: ${props => props.theme.colors.mildText};
`;


const GoogleCalendarTab = () => {

  const [loadSetting, setLoadSetting] = useState(false);

  const [format_fields, setFormatFields] = useState({
    format_google_event_title: null,
    format_google_event_description: null
  })

  const [format_fields_errors, setFormatFieldsErrors] = useState({
    format_google_event_title: null,
    format_google_event_description: null
  });

  const theme = useTheme();

  const { data, modifySetting } = usePageData() || {};

  console.log(data, "data");

  const { data: setting, isLoading } = useQuery({
    queryKey: ['settings/calendar', 'google'],
    queryFn: () => getSetting(`settings/calendar`, `google`),
    enabled: !!data?.integration_id || loadSetting
  })

  console.log(setting, "setting");

  let settingsData = setting?.data || {};

  const handleChange = (e, field) => {
    let val = e.target.value;
    setFormatFieldsErrors(x => ({...x, [field]: null}));
    setFormatFields(x => ({...x, [field]: val}));
  }

  const handleChangeSwitch = (e, field) => {
    let val = e.target.checked;
    modifySetting(val, field, setting?.setting_id);
  }

  const submitFormat = (e, field) => {
    let val = format_fields[field];
    let validatedString = validateTemplate(val);
    if (!validatedString.isValid) {
      setFormatFieldsErrors(x => ({
        ...x,
        [field]: validatedString.errors
      }));
      return;
    }
    modifySetting(val, field, setting?.setting_id);
  }

  useEffect(() => {
    // Listen for messages from popup
    const handleMessage = (event) => {
      // Security check - verify the message is from your backend
      // In production, check: if (event.origin !== 'https://yourapp.com') return;
      
      // console.log('Received message:', event.data);
      
      if (event.data.type === 'google_calendar_success') {
        console.log('Calendar connected successfully!');
        setLoadSetting(true);
        // Refresh integration status, show success message, etc.
        // fetchIntegrationStatus();
      }
    };
    window.addEventListener('message', handleMessage);

    return () => {
      window.removeEventListener('message', handleMessage);
    };
  }, []);


 const handleConnect = () => {
    // Popup dimensions
    const width = 760;
    const height = 600;
    const left = window.screen.width / 2 - width / 2;
    const top = window.screen.height / 2 - height / 2;

    // Open popup
    const popup = window.open(
      'https://novosalon.app/api/integrations/auth/google',
      'Google Calendar Authorization',
      `width=${width},height=${height},left=${left},top=${top},toolbar=no,menubar=no,scrollbars=yes,resizable=yes`
    );

    // Close after 10 seconds
    // setTimeout(() => {
    //   if (popup && !popup.closed) {
    //     popup.close();
    //   }
    // }, 30000);
  };

  return ( !data?.integration_id ?

      <Card variant="outlined">
        <CardHeader title={<Header>
        <Avatar sx={{ bgcolor: theme.palette.primary.main, width: 50, height: 50 }} variant="rounded" >
          <CalendarMonthIcon sx={{ fontSize: 30, color: 'white' }} />
        </Avatar>
        <HeaderContent>
          <Title>Google Calendar</Title>
          <Status>
            <StatusDot />
            Not connected
          </Status>
        </HeaderContent>
      </Header>} />
     

      <CardContent>
        <Description>
          Sync your appointments and events automatically with Google Calendar. 
          Keep everything in one place and never miss appointments.
        </Description>
      </CardContent>

      <CardActions>
        <Button startIcon={<GoogleIcon />} onClick={handleConnect} variant="outlined" color="tertiary">Sign in with Google</Button>
      </CardActions>
    </Card> : 
    <Panel>

    <Section title="Sync Software To Google Calendar" description="Update your appointments and events in Google Calendar every time you add or delete an event" mainAction={<Switch name="sync_to_google" checked={settingsData["sync_to_google"]} onChange={(e) => handleChangeSwitch(e, "sync_to_google")} />} />

    <Section title="Sync Google Calendar To Software" description="Import your appointments and events from Google Calendar. COMING SOON..." mainAction={<Switch name="sync_to_local" checked={settingsData["sync_to_local"]} onChange={(e) => handleChangeSwitch(e, "sync_to_local")} disabled />} />

    <Section title="Format Google Event Title" description="Format the way your events are displayed in Google Calendar. Display the Google event title the way you want it.">

      <TagRuleDescription>
        Set up the event title by using the placeholders below.
        <TagRules>
          <li><b>{`{{client_name}}`}</b> will be replaced with the customer name</li>
          <li><b>{`{{stylist_name}}`}</b> will be replaced with the stylist name</li>
          <li><b>{`{{event_title}}`}</b> will be replaced with the event title, e.g. "Wash & Set"</li>
        </TagRules>
      </TagRuleDescription>
      <TagField placeholder="Event Title" variant="outlined" multiline minRows={3} fullWidth defaultValue={settingsData?.format_google_event_title} onChange={(e) => handleChange(e, "format_google_event_title")} slotProps={{spellCheck: false}} />
      {format_fields_errors?.format_google_event_title ? <ErrorList>
        {format_fields_errors?.format_google_event_title?.map((error, index) => <li key={index}>{error}</li>)}
      </ErrorList> : null}
      <Button variant="outlined" onClick={(e) => submitFormat(e, "format_google_event_title")}>Update Format</Button>
      
    </Section>

    <Section title="Format Google Event Description" description="Format the way your events are displayed in Google Calendar. Display the Google event description the way you want it.">

      <TagRuleDescription>
        Set up the event description by using the placeholders below.
        <TagRules>
          <li><b>{`{{client_name}}`}</b> will be replaced with the customer name</li>
          <li><b>{`{{stylist_name}}`}</b> will be replaced with the stylist name</li>
          <li><b>{`{{event_title}}`}</b> will be replaced with the event title, e.g. "Wash & Set"</li>
          <li><b>{`{{date}}`}</b> will be replaced with the event date</li>
          <li><b>{`{{start_time}}`}</b> will be replaced with the start time</li>
          <li><b>{`{{end_time}}`}</b> will be replaced with the end time</li>
        </TagRules>
      </TagRuleDescription>
      <TagField placeholder="Event Description" variant="outlined" multiline minRows={3} fullWidth defaultValue={settingsData?.format_google_event_description} onChange={(e) => handleChange(e, "format_google_event_description")} slotProps={{spellCheck: false}} />
      {format_fields_errors?.format_google_event_description ? <ErrorList>
        {format_fields_errors?.format_google_event_description?.map((error, index) => <li key={index}>{error}</li>)}
      </ErrorList> : null}
      <Button variant="outlined" onClick={(e) => submitFormat(e, "format_google_event_description")}>Update Format</Button>
      
    </Section>

    </Panel>

  )
};

export default GoogleCalendarTab;